module.exports = __webpack_public_path__ + "static/media/catalouge-34.4daffc91.jpg";